import React from "react";
import MuiContainer from "@mui/material/Container";
import PropTypes from "prop-types";

/**
 * Container component wrapper for layout centering.
 * Wraps Material-UI Container with theme integration.
 * 
 * @component
 * @example
 * <Container maxWidth="sm">
 *   <Typography>Content</Typography>
 * </Container>
 */
const Container = React.forwardRef(({ children, ...props }, ref) => {
  return <MuiContainer ref={ref} {...props}>{children}</MuiContainer>;
});

Container.displayName = 'Container';

Container.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, the left and right padding is removed
   */
  disableGutters: PropTypes.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint
   */
  fixed: PropTypes.bool,
  /**
   * Determine the max-width of the container
   */
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", false]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Container behavior
// MUI Container defaults: maxWidth="lg"

export default Container;

